import { ExtendAccessErrorCode, type ExtendAccessErrorBody } from "@fitness-app/data-models/entities/ExtendAccess";

/** What `setExtendAccessPeriod` rejects with — enough for the panel to say why the change was refused. */
export type ExtendAccessPeriodError = {
  code: ExtendAccessErrorCode | null;
  subscriptionStatus: string | null;
  message: string | null;
};

const KNOWN_CODES: readonly string[] = Object.values(ExtendAccessErrorCode);

const isKnownCode = (code: unknown): code is ExtendAccessErrorCode =>
  typeof code === "string" && KNOWN_CODES.includes(code);

export const getExtendAccessPeriodError = (error: unknown): ExtendAccessPeriodError => {
  const data = (error as { response?: { data?: Partial<ExtendAccessErrorBody> } } | null)?.response?.data;

  return {
    code: isKnownCode(data?.code) ? data.code : null,
    subscriptionStatus: typeof data?.subscriptionStatus === "string" ? data.subscriptionStatus : null,
    message: typeof data?.message === "string" && data.message ? data.message : null,
  };
};
